/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"
import { ProjectPhaseFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProjectPhasesQueryVariables = Exact<{ [key: string]: never }>

export type ProjectPhasesQuery = {
  __typename: "Query"
  projectPhases?: Array<{
    __typename: "ProjectPhase"
    id: string
    value: string
    label: string
  }> | null
}

export const ProjectPhasesDocument = gql`
  query ProjectPhases {
    projectPhases
      @rest(type: "ProjectPhase", path: "/project-list/projects/phases") {
      ...ProjectPhase
    }
  }
  ${ProjectPhaseFragmentDoc}
`

/**
 * __useProjectPhasesQuery__
 *
 * To run a query within a React component, call `useProjectPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPhasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectPhasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProjectPhasesQuery,
    ProjectPhasesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectPhasesQuery, ProjectPhasesQueryVariables>(
    ProjectPhasesDocument,
    options
  )
}
export function useProjectPhasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectPhasesQuery,
    ProjectPhasesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectPhasesQuery, ProjectPhasesQueryVariables>(
    ProjectPhasesDocument,
    options
  )
}
// @ts-ignore
export function useProjectPhasesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectPhasesQuery,
    ProjectPhasesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectPhasesQuery,
  ProjectPhasesQueryVariables
>
export function useProjectPhasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectPhasesQuery,
        ProjectPhasesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectPhasesQuery | undefined,
  ProjectPhasesQueryVariables
>
export function useProjectPhasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectPhasesQuery,
        ProjectPhasesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectPhasesQuery,
    ProjectPhasesQueryVariables
  >(ProjectPhasesDocument, options)
}
export type ProjectPhasesQueryHookResult = ReturnType<
  typeof useProjectPhasesQuery
>
export type ProjectPhasesLazyQueryHookResult = ReturnType<
  typeof useProjectPhasesLazyQuery
>
export type ProjectPhasesSuspenseQueryHookResult = ReturnType<
  typeof useProjectPhasesSuspenseQuery
>
export type ProjectPhasesQueryResult = Apollo.QueryResult<
  ProjectPhasesQuery,
  ProjectPhasesQueryVariables
>
